"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotFileText = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotFileText = _ref => {
  let {
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.4",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_4761_14622)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    fillRule: "evenodd",
    d: "M25.4172 9.70529C20.7272 10.7637 13.2792 12.5515 7.84996 17.8715C2.42074 23.2069 -1.48108 32.5688 1.57093 37.9364C4.63974 43.2886 14.6638 44.6298 23.4908 46.7774C32.3347 48.9404 39.9675 51.9084 45.3015 49.5074C50.6201 47.1092 53.6105 39.3574 55.1995 32.6794C56.8039 26.0013 56.9775 20.4125 55.4193 15.7393C53.8779 11.0675 50.5725 7.32528 46.8121 6.09327C43.0349 4.87807 38.7873 6.15767 35.4343 7.23148C32.0827 8.30388 30.1212 8.63148 25.4172 9.70529Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.1661 4.66602V18.666H47.1661M37.8328 30.3339H19.1661M37.8328 39.666H19.1661M23.8327 21H19.1661M33.1673 4.66602H14.5007C13.263 4.66602 12.076 5.15768 11.2008 6.03285C10.3256 6.90802 9.83398 8.09501 9.83398 9.33268V46.666C9.83398 47.9037 10.3256 49.0907 11.2008 49.9659C12.076 50.841 13.263 51.3327 14.5007 51.3327H42.5006C43.7383 51.3327 44.9253 50.841 45.8005 49.9659C46.6756 49.0907 47.1673 47.9037 47.1673 46.666V18.666L33.1673 4.66602Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_4761_14622"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "56",
    height: "56",
    fill: "white",
    transform: "translate(0.5)"
  }))));
};
exports.SpotFileText = SpotFileText;
SpotFileText.displayName = "SpotFileText";